import RevenueBreakdownTable from "@shared-containers/RevenueBreakdownTable";
import { CustomCardWrapper } from "./styles";

const SalesBreakdown = () => {
  return (
    <CustomCardWrapper>
      <RevenueBreakdownTable pagination />
    </CustomCardWrapper>
  );
};

export default SalesBreakdown;
